import { useEffect } from "react";
import { Header } from "@/components/landing/Header";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";
import { ScrollProgress } from "@/components/landing/ScrollProgress";
import { LeadPopup } from "@/components/landing/LeadPopup";
import { usePageMeta } from "@/seo/usePageMeta";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { About } from "@/components/landing/About";
import { Gallery } from "@/components/landing/Gallery";
import { Testimonials } from "@/components/landing/Testimonials";
import { QuoteForm } from "@/components/landing/QuoteForm";
import { CitiesSection } from "@/components/landing/CitiesSection";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  usePageMeta({ path: "/" });

  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, []);
  return (
    <div data-testid="landing-page">
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Gallery />
        <Testimonials />
        <QuoteForm />
        <CitiesSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <LeadPopup />
    </div>
  );
}
